import { useMemo } from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
const usePluginEntities = (entityKey) => useMemo(() => PluginStore.exports(entityKey), [entityKey]);
export default usePluginEntities;
